import { connect } from 'react-redux';

import { SIGN_UP_FORM } from '../../../constants/FormNames';
import HomeComponent from './HomeNew.component';

const mapStateToProps = ({ forms }) => ({
	formData: forms?.[SIGN_UP_FORM]?.values || {},
});

export default connect(mapStateToProps, {})(HomeComponent);
